'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPopper = require('react-popper');

var _Paper = require('@material-ui/core/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _ClickAwayListener = require('@material-ui/core/ClickAwayListener');

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _Grow = require('@material-ui/core/Grow');

var _Grow2 = _interopRequireDefault(_Grow);

var _MenuItem = require('@material-ui/core/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuList = require('@material-ui/core/MenuList');

var _MenuList2 = _interopRequireDefault(_MenuList);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _HeaderBar = require('./HeaderBar');

var _Typography = require('../Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var colorBackgroundDropdownThemed = _tokens.colorBrandNeutral100;
var colorBackgroundDropdownHoverThemed = _tokens.colorBrandNeutral300;

var styles = function styles(theme) {
    return {
        root: {
            display: 'flex',
            cursor: 'pointer',
            "& [class*='focusVisible']": {
                backgroundColor: theme.palette.primary.dark
            },
            "& .utility [class*='focusVisible']": {
                backgroundColor: 'transparent',
                color: _tokens.colorCtaBlueBase
            }
        },
        dropdownLabel: {
            padding: _tokens.spacingMedium + ' 0'
        },
        dropdownUtilityLabel: {
            paddingLeft: _tokens.spacingSmall,
            paddingRight: _tokens.spacingSmall,
            fontSize: theme.typography.body2.fontSize,
            display: 'flex'
        },
        dropdownMenu: {
            width: '12.5rem',
            backgroundColor: _tokens.colorBrandPrimary,
            '&.themed': {
                backgroundColor: colorBackgroundDropdownThemed
            },

            '&.themed .headerbar-dropdown-menu-item': {
                color: _tokens.colorTextNeutral500
            },
            '&.themed :hover': {
                backgroundColor: colorBackgroundDropdownHoverThemed
            },
            '&.themed :focus': {
                backgroundColor: colorBackgroundDropdownHoverThemed
            }
        },
        dropdownMenuUtility: {
            width: '12.5rem',
            fontSize: theme.typography.body2.fontSize,
            paddingTop: 0
        },
        dropdownMenuItem: {
            color: theme.palette.grey[100],
            whiteSpace: 'normal',
            height: 'auto',
            minHeight: 'auto',
            fontSize: theme.typography.caption.fontSize,
            padding: _tokens.spacingXSmall + ' ' + _tokens.spacingSmall,
            '&:hover': {
                // TODO: We will need logic to figure this out
                // NOTE: This is a placeholder
                backgroundColor: theme.palette.primary.dark
            }
        },
        dropdownMenuItemUtility: {
            color: theme.palette.grey[600],
            whiteSpace: 'normal',
            height: 'auto',
            fontSize: theme.typography.body2.fontSize,
            '&:not(:last-child)': {
                borderBottom: _tokens.borderWidthThin + ' solid ' + theme.palette.grey[400]
            },
            padding: _tokens.spacingXSmall + ' 0.1rem',
            margin: '0 ' + _tokens.spacingSmall,
            '&:hover': {
                backgroundColor: 'transparent',
                color: _tokens.colorCtaBlueBase
            },
            '& a': {
                color: theme.palette.grey[600] + ' !important',
                '&:hover': {
                    backgroundColor: 'transparent',
                    color: _tokens.colorCtaBlueBase + ' !important'
                }
            }
        },
        labeledContent: {
            display: 'flex',
            alignItems: 'center',
            '& div': {
                paddingLeft: _tokens.spacingXSmall,
                paddingTop: _tokens.spacingXSmall
            }
        },
        popperOpen: {
            top: _tokens.spacingMedium + ' !important', // Popper adds inline style so had to use `!important`
            zIndex: theme.zIndex.headerBarDropdown,
            '&.utility': {
                top: '1.3rem !important' // Popper adds inline style so had to use `!important`
            },
            '&> div': {
                borderRadius: 0
            }
        },
        popperClose: {
            top: _tokens.spacingMedium + ' !important', // Popper adds inline style so had to use `!important`
            pointerEvents: 'none',
            '&.utility': {
                top: '1.3rem !important' // Popper adds inline style so had to use `!important`
            }
        },
        dropdownMenuHeader: {
            borderBottom: _tokens.borderWidthThick + ' solid ' + theme.palette.grey[400],
            margin: '0 ' + _tokens.spacingSmall,
            padding: _tokens.spacingSmall + ' 0'
        }
    };
};

var HeaderBarDropdownConsumer = function (_React$Component) {
    _inherits(HeaderBarDropdownConsumer, _React$Component);

    function HeaderBarDropdownConsumer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, HeaderBarDropdownConsumer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderBarDropdownConsumer.__proto__ || Object.getPrototypeOf(HeaderBarDropdownConsumer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            open: false
        }, _this.handleOpen = function (event, context) {
            if (!_this.props.disabled) {
                _this.setState({ open: true }, function () {
                    setTimeout(function () {
                        return context.setOpen(true);
                    });
                });
            }
        }, _this.handleClose = function (event, context, item) {

            // TODO: Use react's equivalent to check node name.
            if (event.type === 'click' && event.target.nodeName === 'LI') {
                var activeLink = document.querySelector('.activeLink');

                if (activeLink) {
                    activeLink.classList.remove('activeLink');
                }
            }

            if (item) {
                // look for child anchors, click them if they're there
                var anchor = event.target && event.target.querySelector('a');

                if (anchor) {
                    anchor.click();
                } else {
                    _this.props.onMenuItemClick(event, item);

                    // let our parent know that an item was selected
                    if (_this.props.itemSelected) {
                        _this.props.itemSelected();
                    }
                }
            }

            _this.setState({ open: false });

            setTimeout(function () {
                return context.setOpen(false);
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HeaderBarDropdownConsumer, [{
        key: 'render',


        /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                classes = _props.classes,
                menuItems = _props.menuItems,
                dropdownMenuLabel = _props.dropdownMenuLabel,
                secondaryDropdownMenuLabel = _props.secondaryDropdownMenuLabel;
            var open = this.state.open;


            var dropdownMenuLabelLocal = dropdownMenuLabel;

            if (secondaryDropdownMenuLabel) {
                dropdownMenuLabelLocal = _react2.default.createElement(
                    'div',
                    { className: this.props.classes.labeledContent },
                    dropdownMenuLabel,
                    _react2.default.createElement(
                        'div',
                        { 'data-key': 'content-label' },
                        secondaryDropdownMenuLabel
                    )
                );
            }
            return _react2.default.createElement(
                _HeaderBar.HeaderBarContext.Consumer,
                null,
                function (context) {
                    var _classNames;

                    return _react2.default.createElement(
                        'div',
                        { className: classes.root,
                            onMouseOver: function onMouseOver(e) {
                                return _this2.handleOpen(e, context);
                            },
                            onFocus: function onFocus(e) {
                                return _this2.handleOpen(e, context);
                            },
                            onMouseLeave: function onMouseLeave(e) {
                                return _this2.handleClose(e, context);
                            },
                            onBlur: function onBlur(e) {
                                return _this2.handleClose(e, context);
                            } },
                        _react2.default.createElement(
                            _reactPopper.Manager,
                            null,
                            _react2.default.createElement(
                                _reactPopper.Target,
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { onClick: function onClick(e) {
                                            return _this2.handleOpen(e, context);
                                        },
                                        ref: function ref(node) {
                                            _this2.target = node;
                                        }
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        { tabIndex: 0, className: _this2.props.isUtility ? classes.dropdownUtilityLabel : classes.dropdownLabel,
                                            onMouseDown: function onMouseDown(e) {
                                                return e.stopPropagation();
                                            },
                                            onMouseUp: function onMouseUp(e) {
                                                return e.stopPropagation();
                                            }
                                        },
                                        dropdownMenuLabelLocal
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _reactPopper.Popper,
                                {
                                    placement: _this2.props.isUtility ? 'bottom-end' : 'bottom',
                                    eventsEnabled: open,
                                    className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, classes.popperClose, !open), _defineProperty(_classNames, classes.popperOpen, open), _defineProperty(_classNames, 'utility', _this2.props.isUtility), _classNames))
                                },
                                _react2.default.createElement(
                                    _ClickAwayListener2.default,
                                    { onClickAway: function onClickAway(e) {
                                            return _this2.handleClose(e, context);
                                        } },
                                    _react2.default.createElement(
                                        _Grow2.default,
                                        { 'in': open, style: { transformOrigin: '0 0 0' } },
                                        _react2.default.createElement(
                                            _Paper2.default,
                                            null,
                                            _this2.props.menuHeader && _react2.default.createElement(
                                                'div',
                                                { className: classes.dropdownMenuHeader },
                                                _react2.default.createElement(
                                                    _Typography2.default,
                                                    null,
                                                    _this2.props.menuHeader
                                                )
                                            ),
                                            _react2.default.createElement(
                                                _MenuList2.default,
                                                { role: 'menu', className: (0, _classnames2.default)(_this2.props.isUtility ? classes.dropdownMenuUtility : classes.dropdownMenu, {
                                                        'themed': _this2.props.context.isThemed()
                                                    }) },
                                                menuItems.filter(function (item) {
                                                    return !item.hidden;
                                                }).map(function (item, index) {
                                                    return _react2.default.createElement(
                                                        _MenuItem2.default,
                                                        {
                                                            key: item.value,
                                                            'data-first': index === 0,
                                                            tabIndex: index === 0 ? 0 : -1,
                                                            className: (0, _classnames2.default)('headerbar-dropdown-menu-item', _this2.props.isUtility ? classes.dropdownMenuItemUtility : classes.dropdownMenuItem, { 'utility': _this2.props.isUtility }),
                                                            role: 'menuitem',
                                                            disabled: item.disabled,
                                                            onClick: function onClick(e) {
                                                                return _this2.handleClose(e, context, item);
                                                            },
                                                            onKeyUp: function onKeyUp(e) {
                                                                if (e.key === 'Enter') {
                                                                    _this2.handleClose(e, context, item);
                                                                }
                                                            }
                                                        },
                                                        item.label
                                                    );
                                                })
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    );
                }
            );
        }
    }]);

    return HeaderBarDropdownConsumer;
}(_react2.default.Component);

// see below for prop descriptions


HeaderBarDropdownConsumer.propTypes = {
    classes: _propTypes2.default.object.isRequired,
    menuItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    dropdownMenuLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    onMenuItemClick: _propTypes2.default.func,
    isUtility: _propTypes2.default.bool,
    secondaryDropdownMenuLabel: _propTypes2.default.string,
    itemSelected: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    menuHeader: _propTypes2.default.string,
    context: _propTypes2.default.object.isRequired // Provided through wrapper

};

HeaderBarDropdownConsumer.defaultProps = {
    disabled: false,
    isUtility: false
};

var HeaderBarDropdown = function HeaderBarDropdown(props) {
    return _react2.default.createElement(
        _HeaderBar.HeaderBarContext.Consumer,
        null,
        function (context) {
            return _react2.default.createElement(HeaderBarDropdownConsumer, Object.assign({}, props, { context: context }));
        }
    );
};

HeaderBarDropdown.propTypes = {
    /** Useful to extend the style applied to components. */
    classes: _propTypes2.default.object.isRequired,

    /** List of menu items with label and callback. */
    menuItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /** A label (or icon) to be displayed for the dropdown */
    dropdownMenuLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,

    /**
     * An additional label that augments the main label, and appers alongside it.
     */
    secondaryDropdownMenuLabel: _propTypes2.default.string,

    /**
     * A callback when an item from dropdown is clicked.
     * This will send and `event` and selected `item` back to callback.
     */
    onMenuItemClick: _propTypes2.default.func,

    /**
     * Whether this should be rendered as a utility menu. For internal use only.
     *
     * @ignore
     */
    isUtility: _propTypes2.default.bool,

    /**
     * When provided, this will be called whenever an item is selected.
     *
     * This is used internally, to manage HeaderBar selection state.
     *
     * @ignore
     */
    itemSelected: _propTypes2.default.func,

    /** Whether this item is disabled */
    disabled: _propTypes2.default.bool,

    /**
     * The header for this dropdwn  (optional)
     */
    menuHeader: _propTypes2.default.string

};

HeaderBarDropdown.defaultProps = {
    disabled: false,
    isUtility: false
};

exports.default = (0, _styles2.default)(styles)(HeaderBarDropdown);